import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/stockholm-fashion-week/sthlmfw-2025.jpg")